const maskCepNo = (value) => {
    return value ? value.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, "+9$1 $2 $3 $4 $5") : null
}

export default maskCepNo